// extracted by mini-css-extract-plugin
module.exports = {"external_link__item":"ExternalLink-module--external_link__item--JoTaE","external_link__item-readmore":"ExternalLink-module--external_link__item-readmore--3OD9W"};